import { createContext, useContext } from 'react';

export type AuthStatus = 'probing' | 'anonymous' | 'authenticated' | 'unknown';

export interface AuthContextValue {
  status: AuthStatus;
  /** The signed-in user's id, or null when anonymous/unknown. In-memory only —
   * the session cookie is HttpOnly, so this is lost on reload (see ADR 0002). */
  userId: string | null;
  login: (email: string, password: string) => Promise<void>;
  /** Registers an account then auto-logs in (register establishes no session). */
  register: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  /** Call when a guarded action throws UnauthorizedError to reset to anonymous. */
  handleUnauthorized: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}
